import SettingsPage from "./pages/SettingsPage";
import PortalSettingsPage from "./pages/PortalSettingsPage";

export const settingsRoutes = [
  {
    path: "/settings",
    element: <SettingsPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },
  {
    // Institute-wide settings: fees, eligibility bars, numbering series.
    // The privilege IS the authority — no role check alongside it, so granting
    // settings.manage to one person is all that is needed, and holding the
    // admin role is not.
    path: "/admin/settings",
    element: <PortalSettingsPage />,
    perms: ["settings.manage"],
  },
];
